module.exports = __webpack_public_path__ + "static/SimplonMono-Regular-WebS.a1d9de29.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SimplonMono-Regular-WebS.ttf
// module id = 303
// module chunks = 114276838955818